import { EmptyState } from '@/design-system';

type Props = {
  isEntityScope: boolean;
};

export const InvestingBoardEmptyState = ({ isEntityScope }: Props) => (
  <EmptyState
    data-testid="investing-board-empty"
    title={isEntityScope ? 'No subscriptions yet' : 'No investments yet'}
    description={
      isEntityScope
        ? 'Subscriptions to your funds appear here as investors move through the flow.'
        : 'Start a subscription from All funds and it will appear here.'
    }
  />
);
